import Stack from '@mui/material/Stack';

import { useTranslation } from '../../hooks';

export default function NoRowsOverlay() {
  const { t } = useTranslation('component');

  return (
    <Stack
      height="100%"
      alignItems="center"
      justifyContent="center"
    >
      {t('noRecords')}
    </Stack>
  );
}
